import { render, staticRenderFns } from "./channelFeeRecord.vue?vue&type=template&id=f968aaea&scoped=true&"
import script from "./channelFeeRecord.vue?vue&type=script&lang=js&"
export * from "./channelFeeRecord.vue?vue&type=script&lang=js&"
import style0 from "./channelFeeRecord.vue?vue&type=style&index=0&id=f968aaea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f968aaea",
  null
  
)

export default component.exports